const get = require('lodash/get')
const find = require('lodash/find')
const isEqual = require('lodash/isEqual')
const pick = require('lodash/pick')

export function compareArr({
  originArr,
  targetArr,
  identifyKey,
  keys = [],
  insideArrField,
  insideArrIdentifyKey,
  insideArrKeys = [],
}) {
  if (!identifyKey) {
    console.error('identifyKey is null')
    return
  }
  if (keys && !Array.isArray(keys)) {
    console.error('keys is not array')
    return
  }

  if (!originArr || (Array.isArray(originArr) && originArr.length === 0)) {
    targetArr.forEach((item) => {
      item.operationType = 'I'
    })
    return targetArr
  }

  if (!targetArr || (Array.isArray(targetArr) && targetArr.length === 0)) {
    originArr.forEach((item) => {
      item.operationType = 'D'
    })
    return originArr
  }

  if (!Array.isArray(originArr) || !Array.isArray(targetArr)) {
    console.error('originArr or targetArr is not array')
    return
  }

  const keysProvided = keys && keys.length > 0

  const resultArr = []

  targetArr.forEach((item) => {
    if (get(item, identifyKey) === undefined) {
      //新規のフラグ
      item.operationType = 'I'
    } else {
      const originItem = find(originArr, (origin) => {
        return get(origin, identifyKey) == get(item, identifyKey)
      })
      if (originItem) {
        const equal = isEqual(
          keysProvided ? pick(originItem, keys) : originItem,
          keysProvided ? pick(item, keys) : item
        )
        if (!equal) {
          //更新のフラグ
          item.operationType = 'U'
        } else {
          item.operationType = null
        }

        if (insideArrField && insideArrIdentifyKey) {
          const originInsideArr = get(originItem, insideArrField)
          const targetInsideArr = get(item, insideArrField)

          const insideArrResult = compareArr({
            originArr: originInsideArr,
            targetArr: targetInsideArr,
            identifyKey: insideArrIdentifyKey,
            keys: insideArrKeys,
          })
          item[insideArrField] = insideArrResult
        }
      }
    }
    resultArr.push(item)
  })

  originArr.forEach((item) => {
    const targetItem = find(targetArr, (target) => {
      return get(target, identifyKey) == get(item, identifyKey)
    })
    if (!targetItem) {
      //削除のフラグ
      item.operationType = 'D'
      resultArr.push(item)
    }
  })

  return resultArr
}

// const arr1 = [
//   {id: 1, name: 'John', age: 20, hobbies: [{id: 1, A: 99, B: 88}]},
//   {id: 2, name: 'shou', age: 21, hobbies: [{id: 2, A: 33}]},
//   {id: 3, name: 'grace', age: 22, hobbies: [{id: 3, A: 44}, {id: 5, A: 55}]},
//   {id: 4, name: 'xxx', age: 22, hobbies: [{id: 4, A: 55}]},
//   {id: 6, name: 'yyy', age: 22, hobbies: null},
// ];

// const arr2 = [
//   {id: 1, name: 'John', age: 20, hobbies: [{id: 1, A: 99}]},
//   {id: 2, name: 'shou', age: 21, hobbies: [{id: 2, A: 33}, {A: 88}]},
//   {id: 3, name: 'grace', age: 32, hobbies: [{id: 3, A: 23}]},
//   {id: 4, name: 'xxx', age: 22, hobbies: null},
//   {id: 6, name: 'xxx', age: 22, hobbies: [{A: 98}]},
// ];

// const arr3 = [
//   { person: { id: 1, name: 'John', age: 20 }, hobbies: { id: 1, A: 99 } },
//   { person: { id: 2, name: 'Johnxxxx', age: 20 }, hobbies: { id: 1, A: 99 } },
//   { person: { id: 3, name: 'Johnbbbb', age: 20 }, hobbies: { id: 1, A: 99 } },
//   { person: { id: 4, name: 'Johncccc', age: 20 }, hobbies: { id: 1, A: 99 } },
//   { person: { id: 5, name: 'Johndddd', age: 20 }, hobbies: { id: 1, A: 99 } },
// ]

// const arr4 = [
//   { person: { id: 1, name: 'Johndddd', age: 20 }, hobbies: { id: 1, A: 99 } },
//   { person: { id: 2, name: 'Johnxxxx', age: 20 }, hobbies: { id: 1, A: 99 } },
//   { person: { id: 3, name: 'Johnbbbb', age: 20 }, hobbies: { id: 1, A: 99 } },
//   { person: { id: 4, name: 'Johncccc', age: 20 }, hobbies: { id: 1, A: 99 } },
//   { person: { id: 5, name: 'Johndddd', age: 20 }, hobbies: { id: 1, A: 99 } },
// ]

// export function testCompareArr() {
//   const result = compareArr({
//     originArr: arr3,
//     targetArr: arr4,
//     identifyKey: 'person.id',
//     keys: ['person.name', 'person.age'],
//   })
//   console.info(result)
// }

// fs.writeFileSync('result.json', JSON.stringify(result));
